export const contactsData = {
    email: 'Ravjodhheer@gmail.com',
    phone: '+1 661-699-3557',
    address: 'San Francisco Bay Area, CA',

    sheetAPI: ''
}